import axios from 'axios'
import './common'

export default {
    getList: (params) => axios.get(`/messages`, { params: params }),
    get: (id) => axios.get(`/messages/${id}`),
    create: (data) => axios.post(`/messages`, data),
    update: (id, data) => axios.put(`/messages/${id}`, data),
    updateAsForm(id, data) {
        data.append("_METHOD", "PUT");
        return axios.post(`/messages/${id}`, data);
    },
    delete: (id) => axios.delete(`/messages/${id}`),
    enable: (id) => axios.patch(`/messages/${id}/enable`),
    disable: (id) => axios.patch(`/messages/${id}/disable`),
    push: (id) => axios.post(`/messages/${id}/push`),
    getPhotos: (params) => axios.get(`/messages/latest-photos`, { params: params }),
    getDocs: (params) => axios.get(`/messages/latest-documents`, { params: params }),
    getUnread: (circle) => axios.get(`/messages/nb-unread/${circle}`),
    report: (id) => axios.patch(`/messages/${id}/report`),
    getReports: (params) => axios.get(`/messages/reports`, { params: params }),
    getProcessed: (params) => axios.get(`/messages/processed`, { params: params }),
    nbReports: () => axios.get(`/messages/nb-reports`),
    keep: (id) => axios.patch(`/messages/${id}/keep`)
}